/* globals alert, clearTimeout, console, module, require, setTimeout */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    ModalDialog = require('./modalDialog'),
    user = require('../models/user'),
    Images = require('../collections/images'),
    configuration = require('../utilities/configuration'),
    cookies = require('../utilities/cookies'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'card program-summary'
    },
    channels: {
        analytics: BackboneRadio.channel('analytics'),
        vaultOut: BackboneRadio.channel('vaultInterface:out')
    },
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        mapContent: 'div[name=mapContent]'
    },
    tagName: 'div',
    template: templates.programSummary,
    focus: function () {
        // console.log('programSummary.focus');
        this.$el.find('button[data-action=select]').focus();
    },
    initialize: function () {
        this.templateContext = {
            popout: this.options.popout,
            distanceZip: this.options.distanceZip,
            urlThumbDisabled: configuration.disabledViews.programSummaryImage ? true : false,
            mapDisabled: configuration.disabledViews.programSummaryMap ? true : false,
            payForGroup: this.model.get('canPayForWithHousingSupport') || this.model.get('canPayPrivate')
        };
        this.listenTo(this.model, 'change', _.bind(function () {
            this.render();
        }, this));
        this.listenTo(user, 'change:JWT', _.bind(function () {
            if (!user.isSignedIn()) {
                this.pendingFavorite = false;
            } else {
                if (this.pendingFavorite) {
                    this.$el.find('button[data-action=favorite]').trigger('click');
                }
            }
        }, this));
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        switch (action) {
            case 'favorite':
                if (user.isSignedIn()) {
                    this.pendingFavorite = false;
                    this.channels.analytics.trigger('event', { category: 'places.program', action: this.model.favorite() ? 'favorite.remove' : 'favorite.add', label: this.model.id });
                    jQuery(event.currentTarget).toggleClass('yes', this.model.favorite(!this.model.favorite()));
                    if (!cookies.hasItem('programMarkedFavorite')) {
                        if (this.model.favorite()) {
                            // only show the dialog if there was no cookie set and the user added favorite status (as opposed to removed favorite statue)
                            this.modalDialog = new ModalDialog({template: templates.programMarkedFavorite, templateContext: {}, modalModal: false});
                        }
                        cookies.setItem('programMarkedFavorite', true);
                    }
                } else {
                    this.pendingFavorite = true;
                    if (configuration.embedded) {
                        this.channels.vaultOut.trigger('requestLogon');
                    } else {
                        this.modalDialog = new ModalDialog({template: templates.pleaseSignIn, templateContext: {}, modalModal: false});
                    }
                }
                break;
            case 'select':
                this.trigger('select:program', this);
                break;
            default:
                break;
        }
    }
});
